export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "mapbox-gl-csp-worker-f5d9b048baa13f78b71a.worker.js");
}
